<template>
<div>
    <div><h3>Cultural Resources Search</h3></div>
        <loader v-show="isInitLoading"/>
        <div class="col-md-12" style="min-height: 150px;" v-show="!isInitLoading">
            <div>
                <tabs nav-style="tabs" v-model="activeTabIndex">
                    <tab header="Sites">
                        <form @submit.prevent class="form-horizontal">
                            <div class="form-group">
                                <div class="col-sm-2">
                                    <label for="searchSmithNumber">Smithsonian No</label>
                                </div>
                                <div class="col-sm-3">
                                    <input class="form-control" type="text" name="searchSmithNumber" placeholder="eg: AB123 or AB123_1" v-model="culturalResourceSearchDto.smithsonianNumber">
                                </div>
                                <div class="col-sm-2 col-sm-offset-1">
                                    <label for="searchSiteName">Site Name</label>
                                </div>
                                <div class="col-sm-4">
                                    <input class="form-control" type="text" name="searchSiteName" v-model="culturalResourceSearchDto.siteName">
                                </div>
                            </div>
                            <div class="form-group">
                                <div class="col-sm-2">
                                    <label for="searchSiteType">Site Type</label>
                                </div>
                                <div class="col-sm-3">
                                    <select class="form-control" name="searchSiteType" v-model="culturalResourceSearchDto.siteTypeId">
                                        <option :value="null">Select</option>
                                        <option v-for="siteType in siteTypeList" :value="siteType.id" :key="siteType.id">{{siteType.description}}</option>
                                    </select>
                                </div>
                                <div class="col-sm-2 col-sm-offset-1">
                                    <label for="searchTimePeriod">Time Period</label>
                                </div>
                                <div class="col-sm-3">
                                    <select class="form-control" name="searchTimePeriod" v-model="culturalResourceSearchDto.timePeriodId">
                                        <option :value="null">Select</option>
                                        <option v-for="timePeriod in timePeriodList" :value="timePeriod.id" :key="timePeriod.id">{{timePeriod.description}}</option>
                                    </select>
                                </div>
                            </div>
                            <div class="form-group">
                                <div class="col-sm-2">
                                    <label for="searchNrhpStatus">NRHP Status</label>
                                </div>
                                <div class="col-sm-3">
                                    <select class="form-control" name="searchNrhpStatus" v-model="culturalResourceSearchDto.nrhpStatus">
                                        <option :value="null">Select</option>
                                        <option v-for="status in nrhpStatuses" :value="status.id" :key="status.id">{{status.description}}</option>
                                    </select>
                                </div>
                                <div class="col-sm-2 col-sm-offset-1">
                                    <label for="searchElig">Eligibility</label>
                                </div>
                                <div class="col-sm-3">
                                    <select class="form-control" name="searchElig" v-model="culturalResourceSearchDto.eligibilityId">
                                        <option :value="null">Select</option>
                                        <option v-for="elig in eligibilityList" :value="elig.eligibilityId" :key="elig.eligibilityId">{{elig.description}}</option>
                                    </select>
                                </div>
                            </div>
                            <div class="form-group">
                                <div class="col-sm-2">
                                    <label for="searchIsContributing">Is Contributing</label>
                                </div>
                                <div class="col-sm-3">
                                    <select class="form-control" name="searchIsContributing" v-model="selectedIsContributingFilter">
                                        <option :value="null">Select</option>
                                        <option v-for="option in isContributingOptions" :value="option.value" :key="option.value">{{option.description}}</option>
                                    </select>
                                </div>
                            </div>
                            <div class="form-group">
                                <div class="col-sm-2">
                                    <label for="searchProjName">Project Name</label>
                                </div>
                                <div class="col-sm-3">
                                    <input class="form-control" type="text" name="searchProjName" v-model="culturalResourceSearchDto.projectName">
                                </div>
                                <div class="col-sm-2 col-sm-offset-1">
                                    <label for="searchReportTitle">Report Title</label>
                                </div>
                                <div class="col-sm-4">
                                    <input class="form-control" type="text" name="searchReportTitle" v-model="culturalResourceSearchDto.reportTitle">
                                </div>
                            </div>
                            <div class="form-group">
                                <div class="col-sm-2">
                                    <label for="searchInvDbNumber">DBI Number</label>
                                </div>
                                <div class="col-sm-3">
                                    <input class="form-control" type="text" name="searchInvDbNumber" v-model="culturalResourceSearchDto.invDbNumber">
                                </div>
                                <div class="col-sm-2 col-sm-offset-1">
                                    <label for="searchFieldOrg">Field Org</label>
                                </div>
                                <div class="col-sm-4">
                                    <input class="form-control" type="text" name="searchFieldOrg" v-model="culturalResourceSearchDto.fieldOrg">
                                </div>
                            </div>
                            <div class="form-group">
                                <div class="col-sm-2">
                                    <label for="searchReportYear">Report Year</label>
                                </div>
                                <div class="col-sm-3">
                                    <input class="form-control" type="number" min="0" step="1" name="searchReportYear" v-model="culturalResourceSearchDto.reportYear">
                                </div>
                                <div class="col-sm-2 col-sm-offset-1">
                                    <label for="searchRevNo">Rev No (Legacy)</label>
                                </div>
                                <div class="col-sm-3">
                                    <input class="form-control" type="text" name="searchRevNo" v-model="culturalResourceSearchDto.revNo">
                                </div>

                            </div>
                            <div class="form-group">
                                <div class="col-sm-2">
                                    <label for="searchN9RecId">N9RecId (Legacy)</label>
                                </div>
                                <div class="col-sm-3">
                                    <input class="form-control" type="text" name="searchN9RecId" v-model="culturalResourceSearchDto.n9RecId">
                                </div>
                                <div class="col-sm-2 col-sm-offset-1">
                                    <label for="searchAcno">ACNO (Legacy)</label>
                                </div>
                                <div class="col-sm-3">
                                    <input class="form-control" type="text" name="searchAcno" v-model="culturalResourceSearchDto.acno">
                                </div>
                            </div>
                            <div class="form-group">
                                <div class="col-sm-2">
                                    <label for="searchArtifacts" class="control-label">
                                        Artifacts
                                    </label>
                                </div>
                                <div class="col-sm-10">
                                    <span>{{selectedArtifactDesc}}</span>
                                    <button class="btn btn-secondary" type="button" name="button" v-on:click="$refs['artifactModal'].open()">Select</button>
                                </div>
                                <modal ref="artifactModal">
                                    <div slot="header" class="">
                                        <h3 class="pull-left">Select Artifacts</h3>
                                        <button class="btn pull-right" v-on:click="$refs['artifactModal'].close()">X</button>
                                    </div>
                                    <div slot="body">
                                        <form @submit.prevent class="form-horizontal">
                                            <div class="form-group" v-for="cat in artifactCatList" :key="cat.artifactCategoryId">
                                                <div class="form-inline">
                                                    <label class="control-label">{{cat.description}}</label>
                                                </div>
                                                <div class="checkbox checkbox-inline" v-for="art in artifactList.filter(x => {return x.artifactCategoryId === cat.artifactCategoryId})"
                                                    :key="art.artifactId">
                                                    <input class="form-check-input" type="checkbox" v-model="selectedArtList" :id="art.artifactId + art.description" :value="art.artifactId"></input>
                                                    <label class="form-check-label" :for="art.artifactId + art.description">{{art.description}}</label>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                    <div slot="footer">
                                        <div class="">
                                            <button class="btn btn-primary col-md-3" type="button" name="clear" v-on:click="clearSelectedArtList()">Clear</button>
                                            <button class="btn btn-primary col-md-3" type="button" name="cancel" v-on:click="$refs['artifactModal'].close()">Close</button>
                                        </div>
                                    </div>
                                </modal>
                            </div>
                            <div class="form-group">
                                <div class="col-sm-2">
                                    <label for="searchArtifacts" class="control-label">
                                        Features
                                    </label>
                                </div>
                                <div class="col-sm-10">
                                    <span>{{selectedFeatureDesc}}</span>
                                    <button class="btn btn-secondary" type="button" name="button" v-on:click="$refs['featureModal'].open()">Select</button>
                                </div>
                                <modal ref="featureModal">
                                    <div slot="header" class="">
                                        <h3 class="pull-left">Select Features</h3>
                                        <button class="btn pull-right" v-on:click="$refs['featureModal'].close()">X</button>
                                    </div>
                                    <div slot="body">
                                        <form @submit.prevent class="form-horizontal">
                                            <div class="form-group">
                                                <div class="checkbox checkbox-inline" v-for="feat in featureList" :key="feat.featureId">
                                                    <input class="form-check-input" type="checkbox" v-model="selectedFeatList" :id="feat.featureId + feat.description" :value="feat.featureId"></input>
                                                    <label class="form-check-label" :for="feat.featureId + feat.description">{{feat.description}}</label>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                    <div slot="footer">
                                        <div class="">
                                            <button class="btn btn-primary col-md-3" type="button" name="clear" v-on:click="clearSelectedFeatList()">Clear</button>
                                            <button class="btn btn-primary col-md-3" type="button" name="cancel" v-on:click="$refs['featureModal'].close()">Close</button>
                                        </div>
                                    </div>
                                </modal>
                            </div>
                            <div class="form-group">
                                <div class="col-sm-2">
                                    <label for="searchArtifacts" class="control-label">
                                        Counties
                                    </label>
                                </div>
                                <div class="col-sm-10">
                                    <span>{{selectedCountyDesc}}</span>
                                    <button class="btn btn-secondary" type="button" name="button" v-on:click="$refs['countyModal'].open()">Select</button>
                                </div>
                                <modal ref="countyModal">
                                    <div slot="header" class="">
                                        <h3 class="pull-left">Select Counties</h3>
                                        <button class="btn pull-right" v-on:click="$refs['countyModal'].close()">X</button>
                                    </div>
                                    <div slot="body">
                                        <form @submit.prevent class="form-horizontal">
                                            <div class="form-group">
                                                <div class="checkbox checkbox-inline" v-for="county in countyList" :key="county.countyId">
                                                    <input class="form-check-input" type="checkbox" v-model="culturalResourceSearchDto.countyList" :id="county.countyId + county.description" :value="county.countyId" />
                                                    <label class="form-check-label" :for="county.countyId + county.description">{{county.description}}</label>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                    <div slot="footer">
                                        <div class="">
                                            <button class="btn btn-primary col-md-3" type="button" name="clear" v-on:click="clearSelectedCountyList()">Clear</button>
                                            <button class="btn btn-primary col-md-3" type="button" name="cancel" v-on:click="$refs['countyModal'].close()">Close</button>
                                        </div>
                                    </div>
                                </modal>
                            </div>
                            <!-- <div class="form-group">
                                <div class="col-sm-2">
                                    <label for="searchSmithNumber">County</label>
                                    <button class="btn btn-secondary" type="button" name="clear" v-on:click="clearSelectedCountyList()">Clear</button>
                                </div>
                                <div class="col-sm-4">
                                    <select multiple class="form-control selectpicker" style="height:100%; font-size:14px;" name="searchCounty"
                                        size="6" v-model="culturalResourceSearchDto.countyList">
                                        <option v-for="county in countyList" :value="county.countyId" :key="county.countyId">{{county.description}}</option>
                                    </select>
                                </div>
                                <div class="col-sm-4">
                                    {{selectedCountyDesc}}
                                </div>
                            </div> -->
                            <div class="form-group" style="margin-top:10px;">
                                <div class="col-md-12">
                                    <button class="btn btn-primary" type="button" name="button" v-on:click="searchData()">Search</button>
                                    <button class="btn" type="button" name="button" v-on:click="clearCrSearch()">Clear All</button>
                                    &nbsp;&nbsp;
                                    <label class="control-label text-label" for="crShowInactive">Show Inactive</label>
                                    <input type="checkbox" v-model="culturalResourceSearchDto.showInactive" class="form-check-input" id="crShowInactive" style="width: 15px; height: 15px;"/>
                                </div>
                            </div>
                        </form>
                    </tab>
                    <tab header="Investigations">
                        <form @submit.prevent class="form-horizontal">
                            <div class="form-group">
                                <div class="col-sm-2">
                                    <label for="searchReportTitle">Report Title</label>
                                </div>
                                <div class="col-sm-4">
                                    <input class="form-control" type="text" name="searchReportTitle" v-model="crInvestigationSearchDto.reportTitle">
                                </div>
                                <div class="col-sm-2 col-sm-offset-1">
                                    <label for="searchDbNumber">DB Number</label>
                                </div>
                                <div class="col-sm-3">
                                    <input class="form-control" type="text" name="searchDbNumber" v-model="crInvestigationSearchDto.dbNumber">
                                </div>
                            </div>
                            <div class="form-group">
                                <div class="col-sm-2">
                                    <label for="searchProjectName">Project Name</label>
                                </div>
                                <div class="col-sm-4">
                                    <input class="form-control" type="text" name="searchProjectName" v-model="crInvestigationSearchDto.projectName">
                                </div>
                                <div class="col-sm-2 col-sm-offset-1">
                                    <label for="searchProjectType">Project Type</label>
                                </div>
                                <div class="col-sm-3">
                                    <input class="form-control" type="text" name="searchProjectType" v-model="crInvestigationSearchDto.projectType">
                                </div>
                            </div>
                            <div class="form-group">
                                <div class="col-sm-2">
                                    <label for="searchFieldOrg">Field Org</label>
                                </div>
                                <div class="col-sm-4">
                                    <input class="form-control" type="text" name="searchFieldOrg" v-model="crInvestigationSearchDto.fieldOrgName">
                                </div>
                                <div class="col-sm-2 col-sm-offset-1">
                                    <label for="searchClientName">Client</label>
                                </div>
                                <div class="col-sm-3">
                                    <input class="form-control" type="text" name="searchClientName" v-model="crInvestigationSearchDto.clientName">
                                </div>
                            </div>
                            <div class="form-group">
                                <div class="col-sm-2">
                                    <label for="searchFieldOrg">Agency Name</label>
                                </div>
                                <div class="col-sm-4">
                                    <input class="form-control" type="text" name="searchFieldOrg" v-model="crInvestigationSearchDto.agencyName">
                                </div>
                                <div class="col-sm-2 col-sm-offset-1">
                                    <label for="searchClientName">Agency Number</label>
                                </div>
                                <div class="col-sm-3">
                                    <input class="form-control" type="text" name="searchClientName" v-model="crInvestigationSearchDto.agencyNumber">
                                </div>
                            </div>
                            <div class="form-group">
                                <div class="col-sm-2">
                                    <label for="searchFieldOrgName">Report Date Range</label>
                                </div>
                                <div class="col-sm-2">
                                    <el-date-picker v-model="crInvestigationSearchDto.startDate" type="date" format="MM/dd/yyyy" placeholder="From Date"></el-date-picker>
                                </div>
                                <div class="col-sm-2">
                                    <el-date-picker v-model="crInvestigationSearchDto.endDate" type="date" format="MM/dd/yyyy" placeholder="To Date"></el-date-picker>
                                </div>
                            </div>
                            <div class="form-group">
                                <div class="col-md-2">
                                    <label for="searchDbNumber">Rev No (legacy)</label>
                                </div>
                                <div class="col-md-3">
                                    <input class="form-control" type="text" name="searchDbNumber" v-model="crInvestigationSearchDto.revNo">
                                </div>
                                <div class="col-md-2 col-sm-offset-2">
                                    <label for="searchDbNumber">N9RecId (legacy)</label>
                                </div>
                                <div class="col-md-3">
                                    <input class="form-control" type="text" name="searchDbNumber" v-model="crInvestigationSearchDto.n9RecId">
                                </div>
                            </div>
                            <div class="form-group">
                                <div class="col-sm-2">
                                    <label for="searchAcno">ACNO (Legacy)</label>
                                </div>
                                <div class="col-sm-3">
                                    <input class="form-control" type="text" name="searchAcno" v-model="crInvestigationSearchDto.acno">
                                </div>
                            </div>
                            <div class="form-group">
                                <div class="col-sm-2">
                                    <label for="searchLandManager">Land Manager</label>
                                </div>
                                <div class="col-sm-3">
                                    <select class="form-control" name="searchLandManager" v-model="crInvestigationSearchDto.landManagerTypeId">
                                        <option :value="null">Select</option>
                                        <option v-for="lm in landManagerTypeList" :value="lm.landManagerTypeId" :key="lm.landManagerTypeId">{{lm.description}}</option>
                                    </select>
                                </div>
                                <div class="col-sm-2 col-sm-offset-2">
                                    <label for="searchLandowner">Land Owner</label>
                                </div>
                                <div class="col-sm-3">
                                    <select class="form-control" name="searchLandowner" v-model="crInvestigationSearchDto.landownerTypeId">
                                        <option :value="null">Select</option>
                                        <option v-for="lo in landOwnerTypeList" :value="lo.id" :key="lo.id">{{lo.description}}</option>
                                    </select>
                                </div>
                            </div>
                            <div class="form-group">
                                <div class="col-md-12">
                                    <button class="btn btn-primary" type="button" name="button" v-on:click="searchByInvestigation()">Search</button>
                                    <button class="btn" type="button" name="button" v-on:click="clearInvSearch()">Clear All</button>
                                </div>
                            </div>
                        </form>
                    </tab>
                    <tab header="Investigations by TRS">
                        <form @submit.prevent class="form-horizontal">
                            <plssComponent ref="plssInvestigationComponent" :showTitle="false" :showSaveBtn="false" v-on:savePlss="searchInvestigationsByTRS" :id="searchTypeEnum.inv" :key="invPlssCompKey"></plssComponent>
                            <div class="form-group">
                                <div class="col-md-12">
                                    <button class="btn btn-primary" type="button" name="button" v-on:click="validateTRS(searchTypeEnum.inv)">Search</button>
                                    <button class="btn" type="button" name="button" style="margin-right: 10px;" v-on:click="clearPlss(searchTypeEnum.inv)">Clear All</button>
                                    <button class="btn btn-primary" type="button" name="button" :disabled="isExporting" v-on:click="exportCsv(searchTypeEnum.inv)" v-show="crGridSpec.tableData.length > 0">Export to CSV</button>
                                </div>
                            </div>
                        </form>
                    </tab>
                    <tab v-if="hasGisToken" header="Site TRS">
                        <form @submit.prevent class="form-horizontal">
                            <plssComponent ref="plssComponent" :showTitle="false" :showSaveBtn="false" v-on:savePlss="searchByTRS" :id="searchTypeEnum.cr" :key="crPlssCompKey"></plssComponent>
                            <div class="form-group">
                                <div class="col-md-12">
                                    <label class="control-label text-label" for="crShowInactive">Show Inactive</label>
                                    <input type="checkbox" v-model="culturalResourceSearchDto.showInactive" class="form-check-input" id="crShowInactive" style="width: 15px; height: 15px;"/>
                                </div>
                            </div>
                            <div class="form-group">
                                <div class="col-md-12">
                                    <button class="btn btn-primary" type="button" name="button" v-on:click="validateTRS(searchTypeEnum.cr)">Search</button>
                                    <button class="btn" type="button" name="button" style="margin-right: 10px;" v-on:click="clearPlss(searchTypeEnum.cr)">Clear All</button>
                                    <button class="btn btn-primary" type="button" name="button" :disabled="isExporting" v-on:click="exportCsv(searchTypeEnum.cr)" v-show="crGridSpec.tableData.length > 0">Export to CSV</button>
                                </div>
                            </div>
                        </form>
                    </tab>
                    <tab header="Isolates">
                        <form @submit.prevent class="form-horizontal">
                            <div class="form-group">
                                <div class="col-sm-2">
                                    <label for="searchIsolateNumber">File Number</label>
                                </div>
                                <div class="col-sm-3">
                                    <input class="form-control" type="text" name="searchIsolateNumber" v-model="isolateSearchDto.isolateNumber">
                                </div>
                                <div class="col-sm-2 col-sm-offset-1">
                                    <label for="searchFieldNumber">Field Number</label>
                                </div>
                                <div class="col-sm-4">
                                    <input class="form-control" type="text" name="searchFieldNumber" v-model="isolateSearchDto.fieldNumber">
                                </div>
                            </div>
                            <div class="form-group">
                                <div class="col-sm-2">
                                    <label for="searchNIRecId">Isolate NIRecId</label>
                                </div>
                                <div class="col-sm-3">
                                    <input class="form-control" type="text" name="searchNIRecId" v-model="isolateSearchDto.NIRecId">
                                </div>
                                <div class="col-sm-2 col-sm-offset-1">
                                    <label for="searchResourceType">Resource Type</label>
                                </div>
                                <div class="col-sm-4">
                                    <input class="form-control" type="text" name="searchResourceType" v-model="isolateSearchDto.resourceType">
                                </div>
                            </div>
                            <div class="form-group">
                                <div class="col-sm-2">
                                    <label for="searchIsoLandowner">Landowner</label>
                                </div>
                                <div class="col-sm-3">
                                    <select class="form-control" name="searchIsoLandowner" v-model="isolateSearchDto.landownerTypeId">
                                        <option :value="null">Select</option>
                                        <option v-for="lo in isoLandownerList" :value="lo.id" :key="lo.id">{{lo.description}}</option>
                                    </select>
                                </div>
                                <div class="col-sm-2 col-sm-offset-1">
                                    <label for="searchMaterialsCollected">Materials Collected</label>
                                </div>
                                <div class="col-sm-4">
                                    <select name="searchMaterialsCollected" class="form-control" v-model="isolateSearchDto.materialsCollectedId" v-validate="'required'" aria-required="true">
                                        <option  :value="null">Select a value</option>
                                        <option :value="1">Yes</option>
                                        <option :value="2">No</option>
                                        <option :value="3">Unknown</option>
                                    </select>
                                </div>
                            </div>
                            <div class="form-group">
                                <div class="col-sm-2">
                                    <label for="searchProjName">Project Name</label>
                                </div>
                                <div class="col-sm-3">
                                    <input class="form-control" type="text" name="searchProjName" v-model="isolateSearchDto.projectName">
                                </div>
                                <div class="col-sm-2 col-sm-offset-1">
                                    <label for="searchReportTitle">Report Title</label>
                                </div>
                                <div class="col-sm-4">
                                    <input class="form-control" type="text" name="searchReportTitle" v-model="isolateSearchDto.reportTitle">
                                </div>
                            </div>
                            <div class="form-group">
                                <div class="col-sm-2">
                                    <label for="searchInvDbNumber">DBI Number</label>
                                </div>
                                <div class="col-sm-3">
                                    <input class="form-control" type="text" name="searchInvDbNumber" v-model="isolateSearchDto.invDbNumber">
                                </div>
                                <div class="col-sm-2 col-sm-offset-1">
                                    <label for="searchFieldOrg">Field Org</label>
                                </div>
                                <div class="col-sm-4">
                                    <input class="form-control" type="text" name="searchFieldOrg" v-model="isolateSearchDto.fieldOrg">
                                </div>
                            </div>
                            <div class="form-group">
                                <div class="col-sm-2">
                                    <label for="searchReportYear">Report Year</label>
                                </div>
                                <div class="col-sm-3">
                                    <input class="form-control" type="number" min="0" step="1" name="searchReportYear" v-model="isolateSearchDto.reportYear">
                                </div>
                                <div class="col-sm-2 col-sm-offset-1">
                                    <label for="searchRevNo">Rev No (Legacy)</label>
                                </div>
                                <div class="col-sm-3">
                                    <input class="form-control" type="text" name="searchRevNo" v-model="isolateSearchDto.revNo">
                                </div>

                            </div>
                            <div class="form-group">
                                <div class="col-sm-2">
                                    <label for="searchN9RecId">N9RecId (Legacy)</label>
                                </div>
                                <div class="col-sm-3">
                                    <input class="form-control" type="text" name="searchN9RecId" v-model="isolateSearchDto.n9RecId">
                                </div>
                                <div class="col-sm-2 col-sm-offset-1">
                                    <label for="searchAcno">ACNO (Legacy)</label>
                                </div>
                                <div class="col-sm-3">
                                    <input class="form-control" type="text" name="searchAcno" v-model="isolateSearchDto.acno">
                                </div>
                            </div>
                            <div class="form-group">
                                <div class="col-sm-2">
                                    <label for="searchArtifacts" class="control-label">
                                        Counties
                                    </label>
                                </div>
                                <div class="col-sm-10">
                                    <span>{{selectedIsoCountyDesc}}</span>
                                    <button class="btn btn-secondary" type="button" name="button" v-on:click="$refs['isoCountyModal'].open()">Select</button>
                                </div>
                                <modal ref="isoCountyModal">
                                    <div slot="header" class="">
                                        <h3 class="pull-left">Select Counties</h3>
                                        <button class="btn pull-right" v-on:click="$refs['isoCountyModal'].close()">X</button>
                                    </div>
                                    <div slot="body">
                                        <form @submit.prevent class="form-horizontal">
                                            <div class="form-group">
                                                <div class="checkbox checkbox-inline" v-for="county in countyList" :key="'iso_co_' + county.countyId">
                                                    <input class="form-check-input" type="checkbox" v-model="isolateSearchDto.countyList" :id="'iso_' + county.countyId + county.description" :value="county.countyId" />
                                                    <label class="form-check-label" :for="'iso_' + county.countyId + county.description">{{county.description}}</label>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                    <div slot="footer">
                                        <div class="">
                                            <button class="btn btn-primary col-md-3" type="button" name="clear" v-on:click="clearIsoSelectedCountyList()">Clear</button>
                                            <button class="btn btn-primary col-md-3" type="button" name="cancel" v-on:click="$refs['isoCountyModal'].close()">Close</button>
                                        </div>
                                    </div>
                                </modal>
                            </div>
                            <div class="form-group" style="margin-top:10px;">
                                <div class="col-md-12">
                                    <button class="btn btn-primary" type="button" name="button" v-on:click="searchIsolateData()">Search</button>
                                    <button class="btn" type="button" name="button" v-on:click="clearIsoSearch()">Clear All</button>
                                </div>
                            </div>
                        </form>
                    </tab>
                    <tab v-if="hasGisToken" header="Isolates By TRS">
                        <form @submit.prevent class="form-horizontal">
                            <plssComponent ref="plssIsolateComponent" :showTitle="false" :showSaveBtn="false" v-on:savePlss="searchByIsolateTRS" :id="searchTypeEnum.iso" :key="isoPlssCompKey"></plssComponent>
                            <div class="form-group">
                                <div class="col-md-12">
                                    <button class="btn btn-primary" type="button" name="button" v-on:click="validateTRS(searchTypeEnum.iso)">Search</button>
                                    <button class="btn" type="button" name="button" style="margin-right: 10px;" v-on:click="clearPlss(searchTypeEnum.iso)">Clear All</button>
                                    <!-- <button class="btn btn-primary" type="button" name="button" :disabled="isExporting" v-on:click="exportCsv('CulturalResource')" v-show="crGridSpec.tableData.length > 0">Export to CSV</button> -->
                                </div>
                            </div>
                        </form>
                    </tab>
                </tabs>
                <loader v-show="isLoading"/>
                <v-client-table v-show="!isLoading" :data="crGridSpec.tableData" :columns="crGridSpec.columns" :options="crGridSpec.options">
                    <template slot="select" slot-scope="props">
                        <div style="text-align: center">
                            <router-link :to="{ path: '/CulturalResource/' + props.row.culturalResourceId }" v-if="props.row.culturalResourceId" tag="a" class="fa fa-edit" style="font-size: 16px;"></router-link>
                            <router-link :to="{ path: '/Investigation/' + props.row.investigationId }" v-if="props.row.investigationId" tag="a" class="fa fa-edit" style="font-size: 16px;"></router-link>
                            <router-link :to="{ path: '/Isolate/' + props.row.isolateId }" v-if="props.row.isolateId" tag="a" class="fa fa-edit" style="font-size: 16px;"></router-link>
                        </div>
                    </template>
                    <template slot="resources" slot-scope="props">
                        <div style="text-align: center;">
                            <span v-if="props.row.siteCount > 0 || props.row.isolateCount > 0">Yes&nbsp;</span>
                            <router-link :to="{ path: '/Investigation/' + props.row.investigationId, hash: '#siteSummary' }" tag="a" class="fa fa-edit" style="font-size: 16px;" v-if="props.row.siteCount > 0 || props.row.isolateCount > 0"></router-link>
                            <span v-else>No</span>
                        </div>
                    </template>
                </v-client-table>
            </div>
        </div>
    </div>
</template>

<script>
import culturalResourceService from '@/services/culturalResourceService'
import investigationService from '@/services/investigationService'
import gisService from '@/services/gisService'
import mediaService from '@/services/mediaService'
import lookupService from '@/services/lookup/lookupService'
import artifactService from '@/services/lookup/artifactService'
import featureService from '@/services/lookup/featureService'
import countyService from '@/services/lookup/countyService'
import landOwnershipService from '@/services/landOwnershipService'
import evaluationService from '@/services/siteForm/evaluationService'
import isolateService from '@/services/isolateService'
import userService from '@/services/userService'
import roleService from '@/services/roleService'

import loader from '@/components/Loader'
import { tab, tabs } from 'vue-strap'
import { mapState } from 'vuex'
import plssComponent from '@/components/PlssComponent'
import modal from '@/components/Modal.vue'

export default {
    components: {
        loader,
        tabs,
        tab,
        plssComponent: plssComponent,
        modal
    },
    data: function () {
        return {
            isLoading: false,
            isInitLoading: true,
            isExporting: false,
            activeTabIndex: 0,
            culturalResource: {},
            culturalResourceRecordings: [],
            currentSearchType: null,
            culturalResourceSearchDto: {
                smithsonianNumber: '',
                siteName: '',
                eligibilityId: null,
                isContributing: null,
                countyList: []
            },
            crInvestigationSearchDto: {
                dbNumber: '',
                reportTitle: ''
            },
            isolateSearchDto: {
                countyList: []
            },
            nrhpStatuses: [
                {id: 'listed', description: 'Listed'},
                {id: 'monument', description: 'Monument'},
                {id: 'landmark', description: 'Landmark'},
                {id: 'keeper', description: 'Keeper Determined'}
            ],
            timePeriodList: [],
            siteTypeList: [],
            artifactList: [],
            artifactCatList: [],
            selectedArtList: [],
            featureList: [],
            selectedFeatList: [],
            landManagerTypeList: [],
            landOwnerTypeList: [],
            eligibilityList: evaluationService.EligibilityTypeList,
            selectedIsContributingFilter: null,
            isContributingOptions: [
                { value: 'true', description: 'Contributing' },
                { value: 'false', description: 'Not Contributing' },
                { value: 'unevaluated', description: 'Unevaluated' }
            ],
            countyList: [],
            crGridSpec: {
                columns: ['select', 'siteName', 'smithsonianNumber', 'currentEligibilityDescription'],
                options: {
                    dateFormat: 'YYYY-MM-DD',
                    perPage: 5,
                    perPageValues: [5, 10, 25],
                    headings: {
                        select: 'Select',
                        siteName: 'Site Name',
                        smithsonianNumber: 'Smithsonian Number',
                        reportTitle: 'Report Title',
                        dbNumber: 'DB Number',
                        resources: 'Resources',
                        leadAgencyName: 'Lead Agency',
                        fieldOrgName: 'Field Organization',
                        siteTypeDescription: 'Site Type',
                        timePeriodDescription: 'Time Period',
                        currentEligibilityDescription: 'Eligibility',
                        reportDate: 'Report Date',
                        agencyNumber: 'Agency No',
                        isolateNumber: 'File Number',
                        fieldNumber: 'Field Number',
                        resourceType: 'Resource Type'
                    },
                    orderBy: {
                        ascending: true,
                        column: 'smithsonianNumber'
                    }
                },
                tableData: [],
                trsSearchDto: null
            },
            invPlssCompKey: 0,
            crPlssCompKey: 0,
            isoPlssCompKey: 0,
            searchTypeEnum: {
                cr: 'cr',
                inv: 'inv',
                iso: 'iso'
            },
            isoLandownerList: isolateService.getLandownerList()
        }
    },
    mounted () {
        this.loadLookups().then(() => { this.isInitLoading = false })
    },
    computed: {
        ...mapState({
            shpoUserDto: state => state.auth.shpoUserDto
        }),
        hasGisToken: function () {
            return this.shpoUserDto.gisToken.token
        },
        selectedArtifactDesc: function () {
            var selectedArtDescList = this.selectedArtList.map(x => {
                return (this.artifactList.find(y => y.artifactId === x) || {description: ''}).description
            })
            return selectedArtDescList.join(', ')
        },
        selectedFeatureDesc: function () {
            var selectedFeatDescList = this.selectedFeatList.map(x => {
                return (this.featureList.find(y => y.featureId === x) || {description: ''}).description
            })
            return selectedFeatDescList.join(', ')
        },
        selectedCountyDesc: function () {
            var selectedCountyDescList = this.culturalResourceSearchDto.countyList.map(x => {
                return (this.countyList.find(y => y.countyId === x) || {description: ''}).description
            })
            return selectedCountyDescList.join(', ')
        },
        selectedIsoCountyDesc: function () {
            var selectedCountyDescList = this.isolateSearchDto.countyList.map(x => {
                return (this.countyList.find(y => y.countyId === x) || {description: ''}).description
            })
            return selectedCountyDescList.join(', ')
        }
    },
    methods: {
        loadLookups () {
            var promises = [
                lookupService.listLookup(this.$http, 'TimePeriod'),
                lookupService.listLookup(this.$http, 'SiteType'),
                artifactService.listArtifact(this.$http),
                artifactService.listArtifactCategory(this.$http),
                featureService.listFeature(this.$http),
                landOwnershipService.listLandManagerTypes(this.$http),
                landOwnershipService.listLandownerTypes(this.$http),
                countyService.listLookup(this.$http)
            ]
            // organizationService.list(this.$http).then(result => {
            //     this.organizationList = result.data //.filter(x => { return (x.isBlmFieldOffice || x.isBlmDistrictOffice) })
            // })
            // lookupService.listLookup(this.$http, 'TimePeriod').then(response => {
            //     this.timePeriodList = response.data
            // })
            // siteTypeService.listLookup(this.$http, 'SiteType').then(response => {
            //     this.siteTypeList = response.data
            // })

            // only CR roles are allowed to search for human remains artifact categories
            const isCrUser = userService.hasRoleCheck(this.shpoUserDto.roleList, roleService.ShpoCrRoleList)

            // category 12 (None) is always applied to this list, but conditionally also
            // exclude human remains (id = 6) when it isn't a CR user
            const artifactCategoryListFilter = isCrUser ? (x) => x.artifactCategoryId !== 12
                                                        : (x) => x.artifactCategoryId !== 12 && x.artifactCategoryId !== 6

            return Promise.all(promises).then(responses => {
                this.timePeriodList = responses[0].data
                this.siteTypeList = responses[1].data
                this.artifactList = responses[2].data
                this.artifactCatList = responses[3].data.filter(artifactCategoryListFilter)
                this.featureList = responses[4].data
                this.landManagerTypeList = responses[5].data
                this.landOwnerTypeList = responses[6].data
                this.countyList = responses[7].data
                return responses
            })
        },
        searchData () {
            this.isLoading = true
            this.trsSearchDto = null
            this.crGridSpec.tableData = []
            this.crGridSpec.columns = ['select', 'siteName', 'smithsonianNumber', 'currentEligibilityDescription']
            this.culturalResourceSearchDto.artifactList = this.selectedArtList
            this.culturalResourceSearchDto.featureList = this.selectedFeatList
            this.applyIsContributingFilter()
            culturalResourceService.searchExtended(this.$http, this.culturalResourceSearchDto).then(result => {
                this.crGridSpec.tableData = result.data
                this.currentSearchType = this.searchTypeEnum.cr
                this.isLoading = false
            })
        },
        searchByInvestigation () {
            this.isLoading = true
            this.trsSearchDto = null
            this.crGridSpec.tableData = []
            this.crGridSpec.columns = ['select', 'dbNumber', 'reportTitle', 'reportDate', 'leadAgencyName', 'agencyNumber', 'fieldOrgName', 'resources']
            investigationService.searchForComplete(this.$http, this.crInvestigationSearchDto).then(result => {
                this.crGridSpec.tableData = result.data
                this.currentSearchType = this.searchTypeEnum.inv
                this.isLoading = false
            })
        },
        validateTRS (searchType) {
            if (searchType === this.searchTypeEnum.cr) {
                this.$refs.plssComponent.savePlss()
            } else if (searchType === this.searchTypeEnum.inv) {
                this.$refs.plssInvestigationComponent.savePlss()
            } else if (searchType === this.searchTypeEnum.iso) {
                this.$refs.plssIsolateComponent.savePlss()
            }
        },
        searchInvestigationsByTRS () {
            this.isLoading = true
            this.trsSearchDto = this.$refs.plssInvestigationComponent.plssData
            this.crGridSpec.tableData = []
            this.crGridSpec.columns = ['select', 'dbNumber', 'reportTitle', 'reportDate', 'leadAgencyName', 'fieldOrgName', 'resources']
            investigationService.searchByPlss(this.$http, this.trsSearchDto).then(result => {
                this.crGridSpec.tableData = result.data
                this.currentSearchType = this.searchTypeEnum.inv
                this.isLoading = false
            })
        },
        searchByTRS () {
            this.isLoading = true
            this.crGridSpec.tableData = []
            var trsDto = this.$refs.plssComponent.plssData
            this.trsSearchDto = trsDto
            this.crGridSpec.columns = ['select', 'smithsonianNumber', 'siteName', 'siteTypeDescription', 'timePeriodDescription', 'currentEligibilityDescription']
            //use gisService to get site results
            gisService.setGisServiceUrls(this.shpoUserDto.gisToken.token)
            gisService.siteTrsLayerQuery(trsDto).then(gisResults => {
                var trsSiteResults = gisResults.map(site => {
                    return {
                        countyCode: site.attributes.County,
                        siteNumber: site.attributes.SiteNo,
                        segment: site.attributes.SegmentId
                    }
                })
                var trsDtoList = []
                if (trsDto.Sections.length > 0) {
                    trsDto.Sections.forEach(section => {
                        trsDtoList.push(
                            {
                                Township: trsDto.Township,
                                TownshipDirection: trsDto.TownshipDirection,
                                Range: trsDto.Range,
                                RangeDirection: trsDto.RangeDirection,
                                Section: section,
                                MeridianId: trsDto.MeridianId
                            }
                        )
                    })
                } else {
                    trsDto.section = 0
                    trsDtoList.push(trsDto)
                }
                var searchDto = {
                    crSearchList: trsSiteResults,
                    plssSearchList: trsDtoList,
                    showInactive: this.culturalResourceSearchDto.showInactive
                }
                //search cultural resources
                culturalResourceService.searchByTrsSiteResults(this.$http, searchDto).then(result => {
                    this.crGridSpec.tableData = result.data
                    this.currentSearchType = this.searchTypeEnum.cr
                    this.isLoading = false
                })
            })
        },
        searchIsolateData () {
            this.isLoading = true
            this.trsSearchDto = null
            this.crGridSpec.tableData = []
            this.crGridSpec.columns = ['select', 'isolateNumber', 'fieldNumber', 'resourceType']
            isolateService.searchExtended(this.$http, this.isolateSearchDto).then(result => {
                this.crGridSpec.tableData = result.data
                this.currentSearchType = this.searchTypeEnum.iso
                this.isLoading = false
            })
        },
        searchByIsolateTRS () {
            this.isLoading = true
            this.crGridSpec.tableData = []
            var trsDto = this.$refs.plssIsolateComponent.plssData
            this.trsSearchDto = trsDto
            this.crGridSpec.columns = ['select', 'isolateNumber', 'fieldNumber', 'resourceType']
            //use gisService to get site results
            gisService.setGisServiceUrls(this.shpoUserDto.gisToken.token)
            gisService.isolateTrsLayerQuery(trsDto).then(gisResults => {
                var isolateResults = gisResults.filter(r => r.attributes.ProdRecord).map(result => {
                    return {
                        isolateId: result.attributes.ProdRecord.split('/').pop(),
                        isolateNumber: result.attributes.ISOID,
                        fieldNumber: result.attributes.IsoFldNum,
                        resourceType: result.attributes.ResrcType,
                        investigationDbi: result.attributes.InvestDBI,
                        fieldOrgName: result.attributes.FieldOrg,
                        landowner: result.attributes.Landowner,
                        collections: result.attributes.Collected
                    }
                })
                this.crGridSpec.tableData = isolateResults
                this.currentSearchType = this.searchTypeEnum.iso
                this.isLoading = false
            })
        },
        exportCsv (type) {
            this.isExporting = true
            if (this.currentSearchType) {
                if (this.currentSearchType === this.searchTypeEnum.cr) {
                    culturalResourceService.generateCsv(this.$http, this.trsSearchDto, this.crGridSpec.tableData).then(response => {
                        mediaService.saveFileToDownload(response, 'CrSearchResults.csv')
                        this.isExporting = false
                    })
                } else if (this.currentSearchType === this.searchTypeEnum.inv) {
                    investigationService.generateCsv(this.$http, this.crGridSpec.tableData).then(response => {
                        mediaService.saveFileToDownload(response, 'InvSearchResults.csv')
                        this.isExporting = false
                    })
                }
            }
        },
        clearSelectedArtList () {
            this.selectedArtList = []
        },
        clearSelectedFeatList () {
            this.selectedFeatList = []
        },
        clearSelectedCountyList () {
            this.culturalResourceSearchDto.countyList = []
        },
        clearIsoSelectedCountyList () {
            this.isolateSearchDto.countyList = []
        },
        clearCrSearchDto () {
            this.culturalResourceSearchDto = {
                smithsonianNumber: '',
                siteName: '',
                eligibilityId: null,
                isContributing: null,
                filterIsContributing: false,
                countyList: []
            }
            this.selectedIsContributingFilter = null
        },
        clearCrSearch () {
            this.clearSelectedArtList()
            this.clearSelectedFeatList()
            this.clearSelectedCountyList()
            this.clearCrSearchDto()
        },
        clearInvSearch () {
            this.crInvestigationSearchDto = {
                dbNumber: '',
                reportTitle: ''
            }
        },
        clearIsoSearch () {
            this.isolateSearchDto = {
                countyList: []
            }
        },
        clearPlss (type) {
            //bind component to a :key and changing the key will re-render the component, effectively resetting it
            if (type === this.searchTypeEnum.inv && this.$refs.plssInvestigationComponent) this.invPlssCompKey++
            if (type === this.searchTypeEnum.cr && this.$refs.plssComponent) this.crPlssCompKey++
            if (type === this.searchTypeEnum.iso && this.$refs.plssIsolateComponent) this.isoPlssCompKey++
        },
        applyIsContributingFilter () {
            this.culturalResourceSearchDto.filterIsContributing = false
            this.culturalResourceSearchDto.isContributing = null

            if (this.selectedIsContributingFilter === null) return

            this.culturalResourceSearchDto.filterIsContributing = true
            if (this.selectedIsContributingFilter === 'true') {
                this.culturalResourceSearchDto.isContributing = true
            } else if (this.selectedIsContributingFilter === 'false') {
                this.culturalResourceSearchDto.isContributing = false
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// CulturalResources.vue?65ee4778